import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export type KnowledgeTab = "documents" | "faqs" | "ask";

interface KnowledgeTabSelectorProps {
  activeTab: KnowledgeTab;
  onTabChange: (tab: KnowledgeTab) => void;
}

export function KnowledgeTabSelector({
  activeTab,
  onTabChange,
}: Readonly<KnowledgeTabSelectorProps>) {
  return (
    <Tabs
      value={activeTab}
      onValueChange={(value: string) => onTabChange(value as KnowledgeTab)}
    >
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="documents">Documents</TabsTrigger>
        <TabsTrigger value="faqs">FAQs</TabsTrigger>
        <TabsTrigger value="ask">Ask</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
